export default __webpack_public_path__ + "static/media/checkbox-red.e4384a30.svg";